import React from "react";
import { Star } from "lucide-react";

/** Sterrenbeoordeling. Zonder onChange is ze alleen-lezen. */
export const Stars = ({ value = 0, onChange, size = "md", testid }) => {
  const dim = size === "sm" ? "h-3.5 w-3.5" : size === "lg" ? "h-8 w-8" : "h-5 w-5";
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const on = n <= Math.round(value);
        const cls = `${dim} transition-transform ${on ? "fill-amber-400 text-amber-400" : "text-muted-foreground/40"}`;
        if (!onChange) return <Star key={n} className={cls} />;
        return (
          <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n}/5`}
            data-testid={testid ? `${testid}-${n}` : undefined}
            className="rounded-full p-0.5 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary">
            <Star className={cls} />
          </button>
        );
      })}
    </div>
  );
};

export default Stars;
